export const HINTTEXT_TYPE = {
  INFO: 'info',
  ERROR: 'error',
};
